import { lazy } from 'react';

export const LogoutLazy = lazy(() => import('./Logout'));
